import { ApolloError } from '@apollo/client'
import { Box, CircularProgressProps } from '@material-ui/core'
import React from 'react'

import ErrorPanel from '../components/utils/ErrorPanel'
import LoadingSpinner from '../components/utils/LoadingSpinner'

export const DEFAULT_SPINNER_SIZE = 50
const FALLBACK_ERROR_MESSAGE = 'Failed to load data'

export const Loader = (spinnerProps: CircularProgressProps) => {
  return (
    <Box alignItems="center" justifyContent="center">
      <LoadingSpinner {...spinnerProps} />
    </Box>
  )
}

const fallback = ({
  error,
  loading,
  options,
  showMessage = false,
}: {
  error?: ApolloError | { message?: string }
  loading?: boolean
  options?: { fallbackErrorMessage?: string; loadingSpinnerSize?: number }
  showMessage?: boolean
}) => {
  if (loading) return <Loader size={options?.loadingSpinnerSize || DEFAULT_SPINNER_SIZE} />

  // eslint-disable-next-line no-console
  console.error(error)
  const message = error?.message || options?.fallbackErrorMessage || FALLBACK_ERROR_MESSAGE

  return <ErrorPanel message={message} showMessage={showMessage} />
}
export default fallback
